import * as React from "react";

const IconHeaderUtilityDropdownUp: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 5"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path fill="#298CF0" d="M4 .375c-.16 0-.32.056-.442.167L.433 3.4a.537.537 0 000 .808c.244.223.64.223.884 0L4 1.754l2.683 2.453c.245.223.64.223.884 0a.537.537 0 000-.808L4.442.542A.654.654 0 004 .375z"/></svg>;
};

export default React.memo(IconHeaderUtilityDropdownUp);
